import { Layout, LegacyCard, Loading, SkeletonBodyText, SkeletonPage } from '@shopify/polaris';

export const ShopifySkeleton: React.FC<{ title?: string }> = ({ title }) => {
  return (
    <>
      <Loading />
      <SkeletonPage title={title}>
        <Layout>
          <Layout.Section>
            <LegacyCard sectioned>
              <SkeletonBodyText />
            </LegacyCard>
          </Layout.Section>
        </Layout>
      </SkeletonPage>
    </>
  );
};
